"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletWithdraw = void 0;
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const applicationWithdrawalActions = __importStar(require("./redux/WalletWithdrawalActions"));
const ai_1 = require("react-icons/ai");
// import { WithdrawModal } from "../../components/withdraw/WithdrawModal";
// import { FItem } from "ferrum-design-system";
// import LoaderIcon from "../../assets/img/loaderIcon.svg";
const WalletWithdraw = ({ WalletWithdrawView, WalletWithdrawProps, }) => {
    var _a, _b, _c, _d, _e, _f;
    const dispatch = (0, react_redux_1.useDispatch)();
    // const [counter, setCounter] = useState<number | undefined>(1);
    const { networkClient, walletAddress } = (0, react_redux_1.useSelector)((state) => state.walletConnector);
    // const { userProfile, authToken } = useSelector(
    //   (state: RootState) => state.walletApplicationWrapper
    // );
    const { 
    // showWithdrawModal,
    isWithdrawing, 
    // isWithdrawn,
    receiveTransactionId,
    // transactionId,
     } = (0, react_redux_1.useSelector)((state) => state.WalletWithdrawer);
    // const handleWithdrawModal = () => {
    //   dispatch(applicationWithdrawalActions.closeWithdrawModal());
    // };
    // const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    const performWithdraw = (tx) => {
        if ((tx === null || tx === void 0 ? void 0 : tx.receiveTransactionId) &&
            (tx === null || tx === void 0 ? void 0 : tx.sendNetwork) === "ALGORAND" &&
            networkClient) {
            dispatch(applicationWithdrawalActions.resetWithdraw());
            dispatch(applicationWithdrawalActions.performNonEVMWithdraw(tx));
        }
        else if ((tx === null || tx === void 0 ? void 0 : tx.receiveTransactionId) &&
            (tx === null || tx === void 0 ? void 0 : tx.receiveNetwork) === "ALGORAND" &&
            networkClient) {
            console.log(tx === null || tx === void 0 ? void 0 : tx.receiveNetwork, "withdraw");
            dispatch(applicationWithdrawalActions.resetWithdraw());
            dispatch(applicationWithdrawalActions.performEVMWithdraw(tx, networkClient, walletAddress));
        }
        else if ((tx === null || tx === void 0 ? void 0 : tx.receiveTransactionId) && networkClient) {
            dispatch(applicationWithdrawalActions.resetWithdraw());
            dispatch(applicationWithdrawalActions.performWithdraw(tx.receiveTransactionId, networkClient));
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(WalletWithdrawView, { prefix: isWithdrawing &&
                WalletWithdrawProps.item.receiveTransactionId ===
                    receiveTransactionId ? (react_1.default.createElement(ai_1.AiOutlineLoading3Quarters, null)) : undefined, title: isWithdrawing &&
                WalletWithdrawProps.item.receiveTransactionId === receiveTransactionId
                ? "Withdrawing"
                : WalletWithdrawProps.item.used === "completed"
                    ? "Processing Sucessful"
                    : WalletWithdrawProps.item.used === "pending"
                        ? "Processing Withdrawal"
                        : WalletWithdrawProps.item.used === "failed"
                            ? "Retry Withdrawal"
                            : ((_a = WalletWithdrawProps.item.payBySig) === null || _a === void 0 ? void 0 : _a.signature) ||
                                ((_c = (_b = WalletWithdrawProps.item.payBySig) === null || _b === void 0 ? void 0 : _b.signatures) === null || _c === void 0 ? void 0 : _c.length)
                                ? "Withdraw Now"
                                : "Waiting for verification", className: "w-100", onClick: () => performWithdraw(WalletWithdrawProps.item), disabled: !(((_d = WalletWithdrawProps.item.payBySig) === null || _d === void 0 ? void 0 : _d.signature) ||
                ((_f = (_e = WalletWithdrawProps.item.payBySig) === null || _e === void 0 ? void 0 : _e.signatures) === null || _f === void 0 ? void 0 : _f.length)) ||
                WalletWithdrawProps.item.used === "completed" ||
                WalletWithdrawProps.item.used === "pending" ||
                (isWithdrawing &&
                    WalletWithdrawProps.item.receiveTransactionId ===
                        receiveTransactionId) })));
};
exports.WalletWithdraw = WalletWithdraw;
//# sourceMappingURL=WalletWithdrawal.js.map